export function get3DCdnUrl() {
    return process.env.REACT_APP_AWS_S3_3D_CDN_CLOUDFRONT_URL || "https://assetpipeline.flux.ai";
}
export function getProcessed3dModelUrl(key) {
    return `${get3DCdnUrl()}/?key=${encodeURIComponent(key)}&format=glb`;
}
//# sourceMappingURL=files.js.map